export const API_NAME_MAX_CHAR = 64;
export const GRAPH_NAME_MAX_CHAR = 64;
export const GRAPH_ID_MAX_CHAR = 27;

export const GRAPH_NAME_MIN_CHAR = 2;
export const GRAPH_ID_MIN_CHAR = 2;

export const DEFAULT_VARIANT_NAME = 'current'; // matching rover
